import { useEffect, useState } from 'react'

export enum PointerType {
  Mouse = 'mouse',
  Touch = 'touch',
  Pen = 'pen',
}

export function usePointerType(
  defaultType: PointerType = PointerType.Mouse
): PointerType | null {
  const [pointerType, setPointerType] = useState<PointerType | null>(
    defaultType
  )

  useEffect(() => {
    const handlePointerDown = (e: PointerEvent) => {
      setPointerType(e.pointerType as PointerType)
    }

    window.addEventListener('pointerdown', handlePointerDown)
    return () => window.removeEventListener('pointerdown', handlePointerDown)
  }, [])

  return pointerType
}
